import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LoginButton = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  if (!isAuthenticated)
  {
    return (<button id = "login-button" onClick={() => loginWithRedirect()}>LOG IN</button>);
    
  }
  else {
    return (null);
  }


  
};

export default LoginButton;